import 'picturefill';
import 'lazysizes';
import React from 'react';
import ReactDOM from 'react-dom';
import MoveTo from 'moveto';
import 'intersection-observer';
import scrollama from 'scrollama';
import Index from '@react/index';
window.addEventListener('DOMContentLoaded', async () => {
    ReactDOM.render(React.createElement(Index, null), document.getElementById('js-root'));
});
window.addEventListener('load', () => {
    const scrollToTop = document.querySelector('.btn-scrollto-top');
    if (scrollToTop === null) {
        return;
    }
    const moveTo = new MoveTo();
    scrollToTop.addEventListener('click', () => {
        moveTo.move(document.body);
    });
    const scroller = scrollama();
    scroller.setup({
        step: '#js-header, #js-root'
    })
        .onStepEnter((evt) => {
        if (evt.direction === 'down' && evt.index === 1) {
            scrollToTop.classList.add('active');
        }
        if (evt.index === 0) {
            scrollToTop.classList.remove('active');
        }
    });
});
